import React from 'react';
import { IUnfoldProviderProps } from './types';
import {
  Colors,
  css,
  getTheme,
  Global,
  Theme,
  UnfoldThemeProvider,
} from '@unfold/theme';

import { Clarkson400, Clarkson500 } from '@unfold/theme';
import { AppStateContainer } from './store';
import { api } from '@unfold/api';

export const UnfoldProvider: React.FC<IUnfoldProviderProps> = ({
  theme = Theme.LIGHT,
  children,
}) => {
  const currentTheme = getTheme(theme);

  const globalStyles = css`
    @font-face {
      font-family: 'Clarkson';
      font-weight: 400;
      src: url('${Clarkson400}') format('woff'),
        url('${Clarkson400}') format('opentype'),
        url('${Clarkson400}') format('truetype');
    }

    @font-face {
      font-family: 'Clarkson';
      font-weight: 500;
      src: url('${Clarkson500}') format('woff'),
        url('${Clarkson500}') format('opentype'),
        url('${Clarkson500}') format('truetype');
    }

    * {
      box-sizing: border-box;
    }

    html,
    body {
      width: 100%;
      height: 100%;
      min-height: 100%;
      overflow: hidden;
      margin: 0;
      padding: 0;
      font-family: 'Clarkson', Helvetica, Arial, sans-serif;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      font-weight: 400;
    }

    input::-webkit-contacts-auto-fill-button {
      visibility: hidden;
      display: none !important;
      pointer-events: none;
      position: absolute;
      right: 0;
    }

    input::-webkit-credentials-auto-fill-button {
      visibility: hidden;
      pointer-events: none;
      position: absolute;
      right: 0;
    }

    /* storybook root fix */
    #root {
      height: 100%;
      overflow-y: scroll;
    }

    #app {
      color: ${currentTheme.name === Theme.LIGHT ? Colors.BLACK : Colors.WHITE};
      width: 100%;
      height: 100%;
      min-height: 100%;
      background-color: ${currentTheme.colors.appBgColor};
    }
  `;
  return (
    <AppStateContainer api={api} isGlobal>
      <UnfoldThemeProvider theme={currentTheme}>
        <Global styles={globalStyles} />
        {children}
      </UnfoldThemeProvider>
    </AppStateContainer>
  );
};
